/* Textliste der markierten Spieler zum Einfügen (z. B. WhatsApp) — reine Funktion, kein DOM.
 *
 * Eine Zeile je Spieler, nach Positionsgruppen mit Überschrift (Reihenfolge und Sortierung wie im Export:
 * playerListExport.js). Es kommen nur Name, Position und Jahrgang vor: keine Telefonnummern, keine
 * Dokumentdaten, keine Links. Die Felder werden einzeln gelesen (Positivliste), nicht aus dem Objekt kopiert.
 */

import { positionGroup } from './positions.js';
import { birthYearOf } from './birthYear.js';
import { sortForExport, EXPORT_GROUP_ORDER } from './playerListExport.js';

const PLACEHOLDER = 'Position TBD';
const clean = (v) => (v == null ? '' : String(v).replace(/\s+/g, ' ').trim());

/** "Vorname Nachname · Position · Jahrgang"; fehlende Teile entfallen (nie "undefined"). */
export function playerTextLine(p) {
  const name = [clean(p.firstName), clean(p.lastName)].filter(Boolean).join(' ');
  const pos = clean(p.pos) === PLACEHOLDER ? '' : clean(p.pos);
  return [name, pos, birthYearOf(p)].filter(Boolean).join(' · ');
}

/**
 * @param {Array} players  die Spieler (schon auf die Markierung eingegrenzt)
 * @param {{ group: (key: string) => string }} labels  Gruppenüberschrift (exportLabels().group)
 * @returns {string}  Gruppen durch Leerzeile getrennt; leer bei keinem Spieler
 */
export function buildPlayerText(players, labels) {
  const sorted = sortForExport(players || []);
  const blocks = [];
  for (const group of EXPORT_GROUP_ORDER) {
    const members = sorted.filter((p) => positionGroup(p.pos) === group);
    if (!members.length) continue;
    blocks.push([labels.group(group), ...members.map(playerTextLine)].join('\n'));
  }
  return blocks.join('\n\n');
}
